export default function withSelectModifierKey(e: Pick<MouseEvent, "shiftKey" | "metaKey">) {
  return e.shiftKey || e.metaKey;
}
